import { Xmark } from '@gravity-ui/icons';
import { Button, Icon, Modal } from '@gravity-ui/uikit';

import { EXIST_QUESTION, OUT, STAY } from '../../header/header-navigation/constants';

import styles from './styles.module.scss';

export const ModalOut = ({ open, setOpen, handleLogOut }: any) => {
	return (
		<Modal open={open} className={styles.modal}>
			<div className={styles.modal__title}>
				<h3>{EXIST_QUESTION}</h3>

				<Button onClick={() => setOpen(false)} view="flat">
					<Icon data={Xmark} size={16} />
				</Button>
			</div>

			<div className={styles.modal__btns}>
				<Button onClick={() => setOpen(false)} size="xl" view="flat" className={styles.modal__btns__stay}>
					{STAY}
				</Button>
				<Button onClick={handleLogOut} size="xl" className={styles.modal__btns__return}>
					{OUT}
				</Button>
			</div>
		</Modal>
	);
};
